import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Quotes API
export const quotesAPI = {
  // Create a new quote request
  createQuote: async (quoteData) => {
    try {
      const response = await axios.post(`${API}/quotes`, quoteData);
      return response.data;
    } catch (error) {
      console.error('Error creating quote:', error);
      throw error;
    }
  },

  // Get all quotes (for admin)
  getAllQuotes: async (statusFilter = null) => {
    try {
      const params = statusFilter ? { status_filter: statusFilter } : {};
      const response = await axios.get(`${API}/quotes`, { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching quotes:', error);
      throw error;
    }
  },

  // Get a specific quote by ID
  getQuote: async (quoteId) => {
    try {
      const response = await axios.get(`${API}/quotes/${quoteId}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching quote:', error);
      throw error;
    }
  },

  // Update quote status
  updateQuoteStatus: async (quoteId, newStatus) => {
    try {
      const response = await axios.patch(`${API}/quotes/${quoteId}/status`, null, {
        params: { new_status: newStatus }
      });
      return response.data;
    } catch (error) {
      console.error('Error updating quote status:', error);
      throw error;
    }
  }
};

// Reviews API
export const reviewsAPI = {
  // Get all reviews
  getReviews: async () => {
    try {
      const response = await axios.get(`${API}/reviews`);
      return response.data;
    } catch (error) {
      console.error('Error fetching reviews:', error);
      throw error;
    }
  },

  // Refresh reviews cache
  refreshReviews: async () => {
    try {
      const response = await axios.post(`${API}/reviews/refresh`);
      return response.data;
    } catch (error) {
      console.error('Error refreshing reviews:', error);
      throw error;
    }
  },

  // Get review stats
  getReviewStats: async () => {
    try {
      const response = await axios.get(`${API}/reviews/stats`);
      return response.data;
    } catch (error) {
      console.error('Error fetching review stats:', error);
      throw error;
    }
  }
};

// Health check
export const healthCheck = async () => {
  try {
    const response = await axios.get(`${API}/health`);
    return response.data;
  } catch (error) {
    console.error('Health check failed:', error);
    throw error;
  }
};
